import React from 'react';
import {Popover} from "react-bootstrap";
import Flag from "./Flag";

const colorDescriptionFlags = [{
    color: 'none',
    description: 'Track is cold'
}, {
    color: 'purple',
    description: 'Warm Session'
}, {
    color: 'green',
    description: 'Race Underway'
}, {
    color: 'red',
    description: 'Race Stopped'
}, {
    color: 'yellow',
    description: 'Race Caution'
}, {
    color: 'white',
    description: 'Last Lap'
}, {
    color: 'checkered',
    description: 'Race Finish'
}];

function FlagPopover(props) {
    return (
        <Popover className="flags-popover" {...props}>
            <Popover.Title as="h4">Flag Status:</Popover.Title>

            <Popover.Content>
                {
                    colorDescriptionFlags.map(({color, description}) => {
                        return <div key={color}>
                            <Flag className="popover-flag" color={color} /><span>{description}</span>
                        </div>
                    })
                }
            </Popover.Content>
        </Popover>
    );
}

export default FlagPopover;